module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Attachments")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.$refs.inputUpload.click()
      }
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputUpload",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.fileSelected
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', [_vm._l((_vm.value), function(item, index) {
    return [_c('v-divider', {
      key: index,
      staticClass: "ma-0"
    }), _vm._v(" "), _c('v-list-tile', [(item.fileLocation == 'unknown') ? _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(item)
        }
      }
    }, [_vm._v("remove")])], 1) : _vm._e(), _vm._v(" "), (item.fileLocation != 'unknown') ? _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('viewFile', item)
        }
      }
    }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.fileName)
      }
    })], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e5a7c50e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5a7c50e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/components/attachments/attachments.vue.html
// module id = 593
// module chunks = 0